import style from './GenericHeader.module.css';

const GenericHeader = ({ children }) => {

    return(
        <div className={ style.container } >
            { children }
        </div>
    )

}

export default GenericHeader;